<script setup lang="ts">
import type { TemplateData, TemplateModule } from '../types/types'
import TemplateModal from './TemplateModal.vue'
import ContestTemplateModal from '@/views/contests/Components/ContestTemplateModal.vue'

const { t } = useI18n()
const { templatesByModule } = useTemplate()

const props = defineProps<{
  module: TemplateModule
  templates: TemplateData[]
  urlParams?: Record<string, string>
}>()

const route = useRoute()
const { user } = useLocalStorage()

const isOpen = ref(false)

const computedModule = computed(() => {
  return props.module === 'legacy-contests' ? 'contests' : props.module
})

const limitedTemplate = computed<TemplateData[]>(() => props.templates.slice(0, 5))

const selectedTemplate = ref<TemplateData>()

const selectTemplate = (template?: TemplateData) => {
  selectedTemplate.value = template
  isOpen.value = !isOpen.value
}

const handleClose = () => {
  isOpen.value = !isOpen.value
  setTimeout(() => (selectedTemplate.value = null), 200)
}

const routeQuery = computed(() => route.query)

function redirectFromSuccessPage() {
  if (
    user.value.merchant.isSelfServe &&
    (routeQuery.value.isFromSuccessPage || routeQuery.value.templateFromSuccessPage)
  ) {
    isOpen.value = true
  }
}

watch(routeQuery, () => {
  redirectFromSuccessPage()
})

redirectFromSuccessPage()
</script>
<template>
  <div class="z-0 rounded-2xl bg-muted px-8 py-5">
    <div class="mb-4 flex flex-col justify-between text-sm lg:flex-row">
      <p class="font-semibold text-foreground">{{ t(`pages.${computedModule}.templates.tips`) }}</p>
      <Button variant="ghost-primary" size="sm" class="mt-1 lg:mt-0" @click="selectTemplate()">
        {{ t(`pages.${computedModule}.templates.seeAllTemplates`) }}
      </Button>
    </div>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
      <BaseTemplateCard
        v-for="(template, index) in limitedTemplate"
        :key="index"
        :title="template.name"
        :icon="templatesByModule[computedModule].icon"
        :button-text="t(`pages.${computedModule}.templates.cards.button`)"
        @click="selectTemplate(template)"
        @action="selectTemplate(template)"
      />
    </div>
    <ContestTemplateModal
      v-if="module === 'contests'"
      :is-open="isOpen"
      :templates="templates"
      :selected-template="selectedTemplate"
      :url-params="urlParams"
      @close="handleClose"
    />
    <TemplateModal
      v-else
      :is-open="isOpen"
      :module="module"
      :templates="templates"
      :selected-template="selectedTemplate"
      :url-params="urlParams"
      @on-close-modal="handleClose"
    />
  </div>
</template>
